import {makeStyles} from "@material-ui/core";

export const styles = {
  badge: {
    borderRadius: 5,
    paddingLeft: 6,
    paddingRight: 6,
    marginRight: 2,
    marginLeft: 2,
  },
  description: {
    border: "1px gray solid",
  },
  tag: {
    backgroundColor: "#0066B3",
    color: "white",
  },
};

export const useStyles = makeStyles(() => ({
  container: {
    height: 400,
    width: "100%",
  },
  dropdownFWSelector: {},
  listContainer: {
    maxHeight: "30%",
  },
  dateTimeContainer: {
    width: "100%",
  },
  divider: {
    paddingTop: 15,
    paddingBottom: 10,
  },
}));